export default (() => {
  window.addEventListener('click', (event) => {
    const link = event.target.closest('[data-nav-link]');
    const className = 'is-expanded';
    if (link) {
      if (link.parentElement.classList.contains(className)) {
        link.parentElement.classList.remove(`${className}`);
      }
      else {
        const siblings = link.closest('.nav__list').querySelectorAll(`.${className}`);
        Array.from(siblings).forEach(sibling => {
          sibling.classList.remove(`${className}`);
        })
        link.parentElement.classList.add(`${className}`);
      }
    }
  });

  window.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-bs-toggle][data-bs-target="#navigation"]');
    if (toggle) {
      window.setTimeout(() => {
        const nav = document.querySelector('.page-header__nav');
        if (nav.classList.contains('show')) {
          document.documentElement.classList.add('nav-expanded');
        }
        else {
          document.documentElement.classList.remove('nav-expanded');
        }
      }, 200);
    }
  });

  window.addEventListener('load', () => {
    const meta = document.querySelector('.nav--meta');
    if (meta) {
      document.documentElement.style.setProperty('--meta-nav-height', `${meta.offsetHeight}px`);
    }

    const nav = document.querySelector('.offcanvas-end ');
    const config = { attributes: true, childList: false, subtree: false };

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {

        if (mutation.attributeName === 'class') {
          const currentState = mutation.target.classList.contains('show');
          if (mutation.target.classList.contains('show')) {
            document.documentElement.classList.add('nav-expanded');
          }
          else {
            document.documentElement.classList.remove('nav-expanded');
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(nav, config);
  });
})();
